// src/Components/Chart_Support_Files/chartIndicatorGetters.js

import { dynamicLevelsGetter } from '../SPX_Indicators/SPX Dynamic Levels';
import { adaptiveLevelsGetter } from '../SPX_Indicators/SPX Adaptive Levels';
import { spxAdaptiveGammaLevelsGetter } from '../SPX_Indicators/SPX Adaptive Gamma Levels';
import { deltaLevelsGetter } from '../SPX_Indicators/SPX Delta Levels';
import { thetaLevelsGetter } from '../SPX_Indicators/SPX Charm Levels';
import { gammaLevelsGetter } from '../SPX_Indicators/SPX Gamma Levels';
import { vegaLevelsGetter } from '../SPX_Indicators/SPX Vanna Levels';
import { totalGEXGetter } from '../SPX_Indicators/SPX Total Gex';
import { totalDeltaGetter } from '../SPX_Indicators/SPX Total Delta';
import { totalThetaGetter } from '../SPX_Indicators/SPX Total Charm';
import { totalVegaGetter } from '../SPX_Indicators/SPX Total Vanna';
import { gexPairGetter } from '../SPX_Indicators/SPX GEX Pair';
import { deltaPairGetter } from '../SPX_Indicators/SPX Delta Pair';
import { thetaPairGetter } from '../SPX_Indicators/SPX Theta Pair';
import { vegaPairGetter } from '../SPX_Indicators/SPX Vega Pair';
import { gexTrendStrengthGetter } from '../SPX_Indicators/SPX Gex Trend Strength';
import { spxZeroGexGetter } from '../SPX_Indicators/SPX 0-GEX Levels';

export async function getCustomIndicators({
  PineJS,
  dynamicLevels,
  topOptions,
  greekExposures,
  gexTrendStrength,
}) {
  const dynamicIndicators = await dynamicLevelsGetter(PineJS, dynamicLevels);
  const adaptiveIndicators = await adaptiveLevelsGetter(PineJS, dynamicLevels);
  const adaptiveGammaIndicators = await spxAdaptiveGammaLevelsGetter(PineJS, topOptions);

  const deltaIndicators = await deltaLevelsGetter(PineJS, topOptions);
  const thetaIndicators = await thetaLevelsGetter(PineJS, topOptions);
  const gammaIndicators = await gammaLevelsGetter(PineJS, topOptions);
  const vegaIndicators = await vegaLevelsGetter(PineJS, topOptions);

  const gexIndicators = await totalGEXGetter(PineJS, greekExposures);
  const netDeltaIndicator = await totalDeltaGetter(PineJS, greekExposures);
  const netThetaIndicator = await totalThetaGetter(PineJS, greekExposures);
  const netVegaIndicator = await totalVegaGetter(PineJS, greekExposures);

  const gexPairIndicator = await gexPairGetter(PineJS, greekExposures);
  const deltaPairIndicator = await deltaPairGetter(PineJS, greekExposures);
  const thetaPairIndicator = await thetaPairGetter(PineJS, greekExposures);
  const vegaPairIndicator = await vegaPairGetter(PineJS, greekExposures);

  const gexTrendStrengthIndicator = await gexTrendStrengthGetter(
    PineJS,
    gexTrendStrength
  );

  // 0-GEX level + ±band corridor. Reads optionsStore directly inside main(), so
  // no data arg needed here. Menu-available; not in loadDefaultIndicators yet —
  // promote to SPX defaults once smoke-tested live on the chart.
  const zeroGexIndicators = await spxZeroGexGetter(PineJS);

  return [
    ...dynamicIndicators,
    ...adaptiveIndicators,
    ...adaptiveGammaIndicators,
    ...deltaIndicators,
    ...thetaIndicators,
    ...gammaIndicators,
    ...vegaIndicators,
    ...gexIndicators,
    ...netDeltaIndicator,
    ...netThetaIndicator,
    ...netVegaIndicator,
    ...gexPairIndicator,
    ...deltaPairIndicator,
    ...thetaPairIndicator,
    ...vegaPairIndicator,
    ...gexTrendStrengthIndicator,
    ...zeroGexIndicators,
  ];
}